import { POIAgentSticky } from './poi-agent-sticky';

export default POIAgentSticky;
